import React from 'react';
import classNames from 'classnames';
import EmptyStateBase from '@alltrails/shared/components/EmptyStateBase';
import Button from '@alltrails/shared/denali/components/Button';

import * as styles from './styles/styles.module.scss';
import WarningIcon from '../../../../assets/images/icons/warning.svg';

import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

type ErrorFallbackProps = {
  retryErrorPage: () => void;
  className?: string;
};

const ErrorFallback = ({ retryErrorPage, className }: ErrorFallbackProps): JSX.Element => (
  <div className={classNames(styles.fallbackContainer, className)}>
    <EmptyStateBase
      className={styles.fallbackContainer}
      icon={<img src={WarningIcon} alt={StringConstantsMixin.strings.SOMETHING_WENT_WRONG} />}
      title={StringConstantsMixin.strings.SOMETHING_WENT_WRONG}
      subText={StringConstantsMixin.strings.CLICK_RETRY}
      cta={
        <Button
          text={StringConstantsMixin.strings.COMMUNITY.EMPTY_STATES.RETRY}
          className={styles.button}
          onClick={retryErrorPage}
          testId={StringConstantsMixin.strings.COMMUNITY.EMPTY_STATES.RETRY}
          variant="primary"
        />
      }
    />
  </div>
);

export default ErrorFallback;
